import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form, Input, DatePicker, Select } from "antd";
import dayjs from "dayjs";
import CrudButtons from "components/button/crudbuttons";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";

const AssignedAssetsForm = ({
	recordData,
	recordId,
	mode,
	employeeId,
	getDetails,
	doCreate,
	doUpdate,
	onCancel,
	submitLabel,
}) => {
	const [form] = Form.useForm();
  const DATE_FORMAT = "YYYY-MM-DD";

	useEffect(() => {
		if (employeeId && recordId > 0) {
			getDetails({
				employeeId,
				assignedAssetId: recordId,
			});
		}
	}, [employeeId, recordId, getDetails]);

	useEffect(() => {
		if (recordData) {
			form.resetFields();

			form.setFieldsValue({
				...recordData,
				eaa_employee_id: employeeId,
				eaa_date_provided: recordData?.eaa_date_provided
					? dayjs(recordData.eaa_date_provided)
					: null,
				eaa_date_returned: recordData?.eaa_date_returned
					? dayjs(recordData.eaa_date_returned)
					: null,
			});
		}
	}, [recordData, employeeId, form]);

	const onSubmit = (formData) => {
		try {
			formData.eaa_employee_id = employeeId;

      formData.eaa_date_provided =
        formData.eaa_date_provided?.format(DATE_FORMAT) || null;

      formData.eaa_date_returned =
        formData.eaa_date_returned?.format(DATE_FORMAT) || null;

			if (recordData?.eaa_id > 0) {
				doUpdate(formData);
			} else {
				doCreate(formData);
			}
		} catch (error) {
			console.error("Save failed:", error);
		}
	};

	return (
		<Form
			className={mode !== "view" ? "form" : ""}
			layout="vertical"
			form={form}
			onFinish={onSubmit}
		>
			<FormItem
				name="eaa_id"
				hidden
			>
				<Input type="hidden" />
			</FormItem>

			<FormItem
				name="eaa_employee_id"
				hidden
			> 
				<Input type="hidden" />
			</FormItem>

			<div className="grid grid-cols-2 gap-x-4 gap-y-2">

				<FormItem
					label="Asset"
					name="eaa_asset_id"
					rules={[requiredField()]}
          className="col-span-2"
				>
					{mode !== "view" ? (
						<Select
							id="eaa_asset_id"
							className="input-field"
							showSearch
							allowClear
							options={recordData?.assetOptions || []}
						/>
					) : (
						<label className="text-base label-value dark:text-white">
							{recordData?.asset_name}
						</label>
					)}
				</FormItem>

				<FormItem
					label="Condition Issued"
					name="eaa_condition_issued_id"
					rules={[requiredField()]}
				>
					{mode !== "view" ? (
						<Select
							id="eaa_condition_issued_id"
							className="input-field"
							showSearch
							allowClear
							options={recordData?.conditionOptions || []}
						/>
					) : (
						<label className="text-base label-value dark:text-white">
							{recordData?.asset_condition_name}
						</label>
					)}
				</FormItem>

				<FormItem
					label="Date Provided"
					name="eaa_date_provided"
					rules={[requiredField()]}
				>
					{mode !== "view" ? (
						<DatePicker
							id="eaa_date_provided"
							className="input-field"
							format={DATE_FORMAT}
							style={{ width: "100%" }}
						/>
					) : (
						<label className="text-base label-value dark:text-white">
							{recordData?.eaa_date_provided}
						</label>
					)}
				</FormItem>

				<FormItem
					label="Date Returned"
					name="eaa_date_returned"
				>
					{mode !== "view" ? (
						<DatePicker
							id="eaa_date_returned"
							className="input-field"
							format={DATE_FORMAT}
							style={{ width: "100%" }}
						/>
					) : (
						<label className="text-base label-value dark:text-white">
							{recordData?.eaa_date_returned || "-"}
						</label>
					)}
				</FormItem>

				<FormItem
					label="Status"
					name="status"
					rules={[requiredField()]}
				>
					{mode !== "view" ? (
						<Select
							id="status"
							className="input-field"
							options={[
								{
									value: "Active",
									label: "Active",
								},
								{
									value: "Returned",
									label: "Returned",
								},
								{
									value: "Lost",
									label: "Lost",
								},
								{
									value: "Damaged",
									label: "Damaged",
								},
							]}
						/>
					) : (
						<label className="text-base label-value dark:text-white">
							{recordData?.status}
						</label>
					)}
				</FormItem>

			</div>

			<div className="w-full flex justify-end">
				{mode === "edit" && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.eaa_id ?? 0}
						isModal={true}
						modalId={
							recordData?.eaa_id > 0
								? "edit_assigned_asset"
								: "add_assigned_asset"
						}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel={submitLabel}
					/>
				)}
			</div>
		</Form>
	);
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AssignedAssetsForm);